export const ROUTE_SIDELINKS = "/sidelinks";
